<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert"/>
      订单妥投信息-(计算距离大于等于1000米为妥投失败，小于1000米为妥投成功)
    </p>
    <template slot="extra">
    </template>
    <Row>
      <Col span="24">
      <Input v-model="query.retCode" placeholder="请输入门店编码" class="public-inp md5"/>
      <Input v-model="query.logisticsCode" placeholder="请输入面单号" class="public-inp md5"/>
      <Input v-model="query.orderId" placeholder="请输入订单号" class="public-inp md5"/>
      <Input v-model="query.receivePerson" placeholder="请输入收件人" class="public-inp md5"/><br/>
      <Input v-model="query.receiveMobile" placeholder="请输入收件人手机号" class="public-inp md5"/>
      <Input v-model="query.deliveryDistance" placeholder="妥投距离" class="public-inp md5"/>
      <DatePicker type="daterange" format="yyyy-MM-dd" v-model="date" placeholder="请选择统计源数据日期区间"
                  style="width: 300px; padding-top: 0px; " confirm :value="date"
                  @on-change="chooseExpiredDatetime"></DatePicker>
      <!--      <span class="public-stretch" @click="open = !open">-->
      <!--                <Icon :type="open?'ios-arrow-up':'ios-arrow-down'"/>{{open?'收起':'展开'}}-->
      <!--                </span>-->
      <!--      <Button type="primary" icon="md-add" class="public-fr" @click="addFn()">添加模版</Button>-->
      <Button class="public-fr" @click="reset()" v-access="'order.delivery.reset'">重置</Button>
      <Button class="public-fr" type="primary" icon="ios-search" @click="getList()"  v-access="'order.delivery.query'">查询</Button>
      <Button class="public-fr" type="primary" icon="md-cloud-upload" @click="download()" :disabled="isDisabled">导出
      </Button>
      </Col>
      <Col span="24">
      <Table
        :style="{marginTop:'10px'}"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList">
        <template slot-scope="{ row,index }" slot="sort">
          <span v-show="false">{{row.code}}</span>
          {{index+1}}
        </template>
        <template slot-scope="{ row}" slot="action">
          <a href="javascript:;" @click="detailFn(row) "  v-access="'order.delivery.details'">详情</a>
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="total"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
      </Col>
    </Row>
  </Card>
</template>
<script>
  import columns from '@/views/task/columns';

  export default {
    data() {
      return {
        visiable: false,
        open: false,
        date: ['', ''],
        query: {
          page: 1,
          rows: 10,
          logisticsCode: "",
          orderId: "",
          receivePerson: "",
          receiveMobile: "",
          retCode: "",
          deliveryDistance: null,
          startDate: null,
          endDate: null,
        },
        columns: [{
          title: 'id',
          key: 'id',
          width: 90,
          fixed: 'left'
        },
          {
            title: '订单号',
            key: 'orderId',
            width: 150
          },
          // {
          //   title: '收件人',
          //   key: 'receivePerson',
          //   width: 90
          // }, {
          //   title: '收件人手机',
          //   key: 'receiveMobile',
          //   width: 120
          // }
          {
            title: '门店类型',
            key: 'retType',
            width: 90
          },
          {
            title: '门店名称',
            key: 'retName',
            width: 210
          },
          {
            title: '门店编号',
            key: 'retCode',
            width: 200
          },
          {
            title: '妥投距离(米)',
            key: 'deliveryDistance',
            width: 110,
          }, {
            title: '妥投地址',
            key: 'deliveryPunchAddress',
            width: 200,
          }, {
            title: '收货地址',
            key: 'addressInfo',
            width: 400,
            render(h, params) {
              let p = JSON.parse(params.row.addressInfo);
              return h("div", p.provinceName + p.cityName + p.countyName + p.streetName + " " + p.addr);
            }
          },
          {
            title: '注册地址',
            key: 'registerAddress',
            width: 150,
          },
          {
            title: '状态',
            key: 'deliveryStatus',
            width: 120,
            fixed: 'right',
            render: (h, params) => {
              let name = "";
              if (params.row.deliveryStatus == 0) name = "未上传经纬度";
              else if (params.row.deliveryStatus == 404) name = "未上传经纬度";
              else if (params.row.deliveryStatus == -255) name = "妥投异常";
              else if (params.row.deliveryStatus == 200) name = "妥投成功";
              else name = params.row.status;
              return h("div", name);
            },
          }, {
            title: '操作',
            slot: 'action',
            width: 80,
            fixed: 'right'
          }],
        tbList: [],
        loading: false,
        total: 0,
        isDisabled: false,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      download() {
        let data = this.query;
        if (this.date != null) {
          data.startDate = this.initTime(this.date, 0);
          data.endDate = this.initTime(this.date, 1);
        }

        this.isDisabled = true;
        this.$api.exportOrderDelivery(data).then(res => {
          if (res.code == '200') {
            try {
              let elemIF = document.createElement("iframe");
              elemIF.src = res.data.url;
              elemIF.style.display = "none";
              document.body.appendChild(elemIF);
            } catch (e) {
              this.$Message.error('下载异常！');
            }
          } else {
            this.$Message.error("导出失败" + res.message);
          }

          this.isDisabled = false;
        })
      },
      chooseExpiredDatetime(v) {
        this.date = v;
      },
      initTime(t, i) {
        if (!t[i]) {
          return ''
        }
        let d = t[i];
        let str = new Date(d);
        return this.tools.formatDate(str);
      },
      getList() {
        let data = this.query;
        if (this.date != null) {
          data.startDate = this.initTime(this.date, 0);
          data.endDate = this.initTime(this.date, 1);
        }
        this.loading = true;
        this.$api.getOrderDeliveryList(data).then(res => {
          this.loading = false;
          if (res.code == '200') {
            this.tbList = res.data;
            this.total = res.total;
          }
        })
      },
      reset() {
        this.query.bizId = "";
        this.query.orderId = "";
        this.query.logisticsCode = "";
        this.query.receiveMobile = "";
        this.query.receivePerson = "";
        this.query.deliveryDistance = null;
        this.query.retCode = "";
        this.$nextTick(() => {
          this.getList();
        })
      },
      uploadToggle() {
        this.visiable = !this.visiable
      },
      // 页码
      pageNumChange(pageNum) {
        this.query.page = pageNum;
        this.getList();
      },
      // 页数
      pageSizeChange(pageSize) {
        this.query.rows = pageSize;
        // 页码变动触发pageNumChange
        if (this.query.page == 1) {
          this.getList();
        } else {
          this.query.page = 1;
        }
      },
      detailFn(d) {
        let addr = JSON.parse(d.addressInfo);
        let addressInfo = addr.provinceName + addr.cityName + addr.countyName + addr.streetName + addr.addr;

        this.$router.push({
          name: 'orderDeliveryDetail',
          query: {
            id: d.id,
            orderLongi: d.orderLongi,
            orderLati: d.orderLati,
            deliveryPunchLng: d.deliveryPunchLng,
            deliveryPunchLat: d.deliveryPunchLat,
            deliveryAddr: d.deliveryPunchAddress,
            address: addressInfo
          }
        });
      }
    }
  }
</script>
<style scoped>
  .md5 {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/delivery.vue